import { gql } from "@apollo/client";

export const typeDef = gql`
  type Result {
    url: String
  }
  type Query {
    advertising(id: Int): Result
  }
`;

export const resolvers = {
  Query: {
    advertising: async (_parent, { id }, { dataSources }) => {
      const result = await dataSources.advertising.getAdvertising(id);
      const url = result?.creatives?.[0]?.url;
      return { url };
    },
  },
};
